export default __webpack_public_path__ + "static/media/food master.2825ed95.png";